import { Link } from 'react-router';

import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';

import { formatArticleTagLabel, getArticleTagPath } from '../tags.ts';

type ArticleTagProps = {
  tag: string;
};

export function ArticleTag({ tag }: ArticleTagProps) {
  return (
    <Link
      to={getArticleTagPath(tag)}
      className="rounded-2xl border border-v1-neutral-40 bg-v1-neutral-20 px-2 py-1 typography-v1-caption1 text-v1-background-200 no-underline hover:border-v1-primary-100"
      onClick={() => {
        sendUserPortalEvent('article_tag_clicked', { tag });
      }}
    >
      {formatArticleTagLabel(tag)}
    </Link>
  );
}
